export const GET_POOL_POSITION_LOADING = "GET_POOL_POSITION_LOADING";
export const GET_POOL_POSITION_SUCCESS = "GET_POOL_POSITION_SUCCESS";
export const GET_POOL_POSITION_ERROR = "GET_POOL_POSITION_ERROR";

export const CHECK_APPROVAL_LOADING = "CHECK_APPROVAL_LOADING";
export const CHECK_APPROVAL_SUCCESS = "CHECK_APPROVAL_SUCCESS";
export const CHECK_APPROVAL_ERROR = "CHECK_APPROVAL_ERROR";

export const PHNX_BALANCE_SUCCESS = "PHNX_BALANCE_SUCCESS";
export const PHNX_BALANCE_ERROR = "PHNX_BALANCE_ERROR";

export const PHNX_DAO_INIT_SUCCESS = "PHNX_DAO_INIT_SUCCESS";
export const PHNX_DAO_INIT_ERROR = "PHNX_DAO_INIT_ERROR";

export const PHNX_STAKE_INIT_SUCCESS = "PHNX_STAKE_INIT_SUCCESS";
export const PHNX_STAKE_INIT_ERROR = "PHNX_STAKE_INIT_ERROR";

export const UNISWAP_PAIR_INIT_SUCCESS = "UNISWAP_PAIR_INIT_SUCCESS";
export const UNISWAP_PAIR_INIT_ERROR = "UNISWAP_PAIR_INIT_ERROR";

export const UNISWAP_ROUTER_INIT_SUCCESS = "UNISWAP_ROUTER_INIT_SUCCESS";
export const UNISWAP_ROUTER_INIT_ERROR = "UNISWAP_ROUTER_INIT_ERROR";

export const CHECK_APPROVAL_UNISWAP_PAIR_SUCCESS =
  "CHECK_APPROVAL_UNISWAP_PAIR_SUCCESS";
export const CHECK_APPROVAL_UNISWAP_PAIR_ERROR =
  "CHECK_APPROVAL_UNISWAP_PAIR_ERROR";

export const CHECK_APPROVAL_PHNXDAO_SUCCESS = "CHECK_APPROVAL_PHNXDAO_SUCCESS";
export const CHECK_APPROVAL_PHNXDAO_ERROR = "CHECK_APPROVAL_PHNXDAO_ERROR";

export const CHECK_APPROVAL_PHNX_STAKING_SUCCESS =
  "CHECK_APPROVAL_PHNX_STAKING_SUCCESS";
export const CHECK_APPROVAL_PHNX_STAKING_ERROR =
  "CHECK_APPROVAL_PHNX_STAKING_ERROR";

export const RESET_ALL_CONTRACT_REDUCER = "RESET_ALL_CONTRACT_REDUCER";
